import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth/auth.service';

@Component({
  selector: 'bom-logged-out-page',
  templateUrl: './logged-out-page.component.html',
  styleUrls: ['./logged-out-page.component.scss'],
})
export class LoggedOutPageComponent {
  constructor(private authService: AuthService, private router: Router) {}

  login() {
    this.authService.login('');
  }
}
